module.exports = __webpack_public_path__ + "static/media/logo.687e20a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 1223
// module chunks = 0